<template>
    <div class="w-full h-[292vw] relative pt-[0vw] flex justify-center">
        <img src="../../assets/img/Mobile/Frame 121.webp" alt="" class="w-full h-auto absolute top-[85vw]">
        <div class="relative w-full h-[58vw]"></div>
        <div class="absolute w-full h-[130vw] bg-gradient-to-b from-[#171717] to-transparent"></div>
        <div class="absolute w-full h-[130vw] bg-gradient-to-b from-[#171717] to-transparent"></div>
        <div class="absolute top-[0vw] h-[72vw] w-[95vw] flex flex-row items-center justify-center">
            <img src="../../assets/img/Desktop/StartJourney/3.webp" alt="" class="h-[57vw]">
            <img src="../../assets/img/Desktop/StartJourney/1.webp" alt="" class="h-[72vw]">
            <img src="../../assets/img/Desktop/StartJourney/2.webp" alt="" class="h-[57vw]">
        </div>
        <!-- Main content -->
        <div class="absolute top-[85vw] flex flex-col items-center">
            <img src="../../assets/img/Desktop/StartJourney/StartJourney.webp" alt="" class="w-[90vw]">
            <p class="w-[90vw] text-center text-white text-[3.25vw] font-semibold font-league mt-[2vw]">
                Ready to embark on an epic hero’s journey? Download Idle Glory now and join the summoner’s community.
                Upgrade your squad, conquer challenges, and unleash your true power! Don’t miss out — victory awaits!
            </p>
            <img src="../../assets/img/Desktop/StartJourney/EnterAerthospng.webp" alt="" class="w-[33.3vw] mt-[5vw]" @click="openWebLink('https://play.idle-glory.io/')">

            <!-- Apple/ Android -->
            <div class="w-[90vw] flex flex-row justify-evenly mt-[10vw]">
                <div class="flex flex-row items-center hover:cursor-pointer w-[40vw]">
                    <img src="../../assets/img/Desktop/StartJourney/Playstore.webp" alt="" class="w-[7.32vw] h-[8.37w]">
                    <p class="font-league text-[3.75vw] font-black ml-[3vw] text-white">Google Play</p>
                </div>
                <div class="h-[9vw] w-[0.5vw] bg-white"></div>
                <div class="flex flex-row items-center hover:cursor-pointer w-[40vw] justify-end">
                    <img src="../../assets/img/Desktop/StartJourney/Apple.webp" alt="" class="w-[7.32vw] h-[8.37w]">
                    <p class="font-league text-[3.75vw] font-black ml-[3vw] text-white">App Store</p>
                </div>
            </div>

            <img src="../../assets/img/Desktop/LogoNav/1.webp" alt="" class="w-[25vw] mt-[8vw]">
            <p class="text-[3.25vw] font-league text-white text-center mt-[5vw]">
                The ultimate turn-based tactical Idle RPG:
                <br/>
                Where strategy and perseverance transform youinto a legend.
            </p>

            <div class="mt-[6vw] w-[44vw] h-[9.3vw] flex flex-row justify-between">
                <img src="../../assets/img/Desktop/StartJourney/Telegram.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
                @click="openWebLink('https://t.me/idleglory_group')">
                <img src="../../assets/img/Desktop/StartJourney/Telegram.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
                @click="openWebLink('https://t.me/idleglory_channel')">
                <img src="../../assets/img/Desktop/StartJourney/prime_twitter.webp" alt="" class="w-[9.3vw] h-[9.3vw]"
                @click="openWebLink('https://x.com/idle_gIory')">
            </div>

            <div class="w-full h-auto flex flex-col items-center mt-[8vw] space-y-[2vw]">
                <p class="font-league text-[4.5vw] font-bold text-white">
                    Story
                </p>
                <p class="font-league text-[4.5vw] font-bold text-white">
                    Feature
                </p>
                <p class="font-league text-[4.5vw] font-bold text-white">
                    Gameplay
                </p>
                <p class="font-league text-[4.5vw] font-bold text-white">
                    Community
                </p>
                <p class="font-league text-[4.5vw] font-bold text-white">
                    Contact
                </p>
                <p class="font-league text-[4.5vw] font-bold text-white">
                    FAQs
                </p>
            </div>

            <p class="text-center mt-[6vw] text-white font-semibold text-[3.25vw] font-league">
                © 2025 Idle Glory. All rights reserved.
            </p>
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
    font-family: "Emeritus", sans-serif;
}

.font-league {
    font-family: "LeagueSpartan", sans-serif;
}
</style>